import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const fmt = v => 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
const th = { padding: '0 12px 10px 0', color: '#9AA3AE', fontSize: '10.5px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', borderBottom: '0.5px solid rgba(26,58,92,0.1)' };
const td = { padding: '11px 12px 11px 0', borderBottom: '0.5px solid rgba(26,58,92,0.07)', fontSize: '13px', color: '#1C2533', verticalAlign: 'middle' };
const filtroInp = { padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" };
const inpStyle = { width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };

const toISO = (d) => d.toISOString().split('T')[0];

const periodos = [
  { key: 'mes', label: 'Este mês' },
  { key: 'mes_ant', label: 'Mês anterior' },
  { key: 'trimestre', label: 'Últimos 3 meses' },
  { key: 'ano', label: 'Este ano' },
  { key: 'todos', label: 'Todos' },
  { key: 'custom', label: 'Personalizado' },
];

const calcPeriodo = (key) => {
  const h = new Date();
  if (key === 'mes') return { ini: new Date(h.getFullYear(), h.getMonth(), 1), fim: new Date(h.getFullYear(), h.getMonth() + 1, 0) };
  if (key === 'mes_ant') return { ini: new Date(h.getFullYear(), h.getMonth() - 1, 1), fim: new Date(h.getFullYear(), h.getMonth(), 0) };
  if (key === 'trimestre') return { ini: new Date(h.getFullYear(), h.getMonth() - 2, 1), fim: h };
  if (key === 'ano') return { ini: new Date(h.getFullYear(), 0, 1), fim: h };
  return null;
};

export default function Vendas() {
  const [vendas, setVendas] = useState([]);
  const [modalReceb, setModalReceb] = useState(null);
  const [formReceb, setFormReceb] = useState({});
  const [clientes, setClientes] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [periodo, setPeriodo] = useState('mes');
  const [customIni, setCustomIni] = useState('');
  const [customFim, setCustomFim] = useState('');
  const [modalEditar, setModalEditar] = useState(false);
  const [form, setForm] = useState({});
  const [salvando, setSalvando] = useState(false);
  const [formasEdit, setFormasEdit] = useState([{ forma: '', valor: '' }]);
  const [modalEntrega, setModalEntrega] = useState(null); // venda_id
  const [dataEntrega, setDataEntrega] = useState('');
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const isAdmin = usuario?.nivel === 'admin' || usuario?.nivel === 'gerente';

  const carregar = async (p, cIni, cFim) => {
    setLoading(true);
    try {
      let params = {};
      if (p === 'custom') {
        if (cIni) params.inicio = cIni;
        if (cFim) params.fim = cFim;
      } else if (p !== 'todos') {
        const datas = calcPeriodo(p);
        if (datas) { params.inicio = toISO(datas.ini); params.fim = toISO(datas.fim); }
      }
      const r = await api.get('/vendas', { params });
      setVendas(r.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    carregar('mes', '', '');
    if (isAdmin) {
      api.get('/clientes').then(r => setClientes(r.data)).catch(() => {});
      api.get('/veiculos').then(r => setVeiculos(r.data)).catch(() => {});
      api.get('/usuarios').then(r => setUsuarios(r.data)).catch(() => {});
    }
  }, []);

  const handlePeriodo = (p) => {
    setPeriodo(p);
    if (p !== 'custom') carregar(p, '', '');
  };

  const abrirEditar = (v) => {
    setForm({
      id: v.id,
      cliente_id: String(v.cliente_id),
      veiculo_id: String(v.veiculo_id),
      vendedor_id: String(v.vendedor_id),
      valor_veiculo: v.valor_veiculo,
      valor_desconto: v.valor_desconto || 0,
      valor_final: v.valor_final,
      valor_transferencia: v.valor_transferencia || 0,
      forma_pagamento: v.forma_pagamento || '',
      observacoes: v.observacoes || '',
      data_venda: v.data_venda ? v.data_venda.split('T')[0] : '',
    });
    setModalEditar(true);
  };

  const salvarEdicao = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      await api.put('/vendas/' + form.id, form);
      setModalEditar(false);
      setForm({});
      carregar(periodo, customIni, customFim);
    } catch (err) { alert(err.response?.data?.error || 'Erro ao salvar'); }
    finally { setSalvando(false); }
  };

  const abrirModalEntrega = (id, e) => {
    e.stopPropagation();
    setModalEntrega(id);
    setDataEntrega(new Date().toISOString().split('T')[0]);
  };

  const confirmarEntrega = async () => {
    try {
      await api.put('/vendas/' + modalEntrega + '/entregar', { data_entrega: dataEntrega || new Date().toISOString().split('T')[0] });
      setModalEntrega(null);
      carregar(periodo, customIni, customFim);
    } catch (err) { alert('Erro: ' + err.message); }
  };

  const abrirDoc = (tipo, id, e) => {
    e.stopPropagation();
    const token = localStorage.getItem('token');
    window.open('https://sistema.autopmotos.com/api/documentos/' + tipo + '/' + id + '?token=' + token, '_blank');
  };

  const setV = (campo, val) => setForm(f => ({ ...f, [campo]: val }));
  const totalReceita = vendas.reduce((a, v) => a + parseFloat(v.valor_final || 0), 0);


  const cancelarVenda = async (v) => {
    if (!window.confirm("Cancelar venda de " + v.marca + " " + v.modelo + " para " + v.cliente_nome + "?\n\nEsta acao ira:\n- Voltar o veiculo para estoque\n- Cancelar os lancamentos financeiros\n- Remover a venda da lista")) return;
    try {
      await api.delete("/vendas/" + v.id);
      setVendas(vs => vs.filter(x => x.id !== v.id));
    } catch(err) { alert(err.response?.data?.error || "Erro ao cancelar venda"); }
  };

  const salvarRecebimento = async () => {
    if (!formReceb.valor || parseFloat(formReceb.valor) <= 0) { alert('Informe o valor'); return; }
    try {
      await api.post('/vendas/' + modalReceb.id + '/recebimento', formReceb);
      setModalReceb(null); setFormReceb({});
      api.get('/vendas').then(r => setVendas(r.data)).catch(console.error);
    } catch(err) { alert(err.response?.data?.error || 'Erro'); }
  };

  const modalRecebJSX = modalReceb && (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '420px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>Registrar Recebimento</h3>
          <button onClick={() => setModalReceb(null)} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>x</button>
        </div>
        <div style={{ background: '#F4F6F9', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', color: '#6B7A8D' }}>
          <strong style={{ color: '#1C2533' }}>{modalReceb.marca} {modalReceb.modelo}</strong> - {modalReceb.cliente_nome}<br/>
          <span>Total: {fmt(modalReceb.valor_final)} - Recebido: {fmt(modalReceb.valor_recebido || 0)} - <strong style={{ color: '#E67E22' }}>Saldo: {fmt(parseFloat(modalReceb.valor_final||0) - parseFloat(modalReceb.valor_recebido||0))}</strong></span>
        </div>
        {[['Valor', 'valor', 'number'], ['Forma de pagamento', 'forma', 'text'], ['Data', 'data', 'date'], ['Descricao', 'descricao', 'text']].map(([l, k, t]) => (
          <div key={k} style={{ marginBottom: '12px' }}>
            <label style={{ color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase' }}>{l}</label>
            <input type={t} value={formReceb[k] || ''} onChange={e => setFormReceb(f => ({ ...f, [k]: e.target.value }))}
              style={{ width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', boxSizing: 'border-box' }} />
          </div>
        ))}
        <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
          <button onClick={() => setModalReceb(null)} style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer' }}>Cancelar</button>
          <button onClick={salvarRecebimento} style={{ flex: 1, padding: '10px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700' }}>Confirmar</button>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>
          Vendas <span style={{ fontSize: '14px', color: '#6B7A8D', fontWeight: '400' }}>({vendas.length})</span>
        </div>
        <button onClick={() => navigate('/vendas/nova')}
          style={{ padding: '9px 18px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
          + Nova Venda
        </button>
      </div>

      {/* Filtros */}
      <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '12px 16px', marginBottom: '14px' }}>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
          {periodos.map(p => (
            <button key={p.key} onClick={() => handlePeriodo(p.key)}
              style={{ padding: '6px 14px', background: periodo === p.key ? '#1A3A5C' : '#F4F6F9', border: 'none', color: periodo === p.key ? '#fff' : '#6B7A8D', borderRadius: '7px', cursor: 'pointer', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: periodo === p.key ? '600' : '400' }}>
              {p.label}
            </button>
          ))}
          {periodo === 'custom' && (
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: '4px' }}>
              <input type='date' value={customIni} onChange={e => setCustomIni(e.target.value)} style={filtroInp} />
              <span style={{ color: '#9AA3AE', fontSize: '13px' }}>até</span>
              <input type='date' value={customFim} onChange={e => setCustomFim(e.target.value)} style={filtroInp} />
              <button onClick={() => carregar('custom', customIni, customFim)}
                style={{ padding: '8px 14px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '7px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600', fontSize: '13px' }}>
                Buscar
              </button>
            </div>
          )}
        </div>
      </div>

      {/* KPIs — vendedor só vê quantidade */}
      {vendas.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: isAdmin ? '1fr 1fr 1fr' : '1fr', gap: '12px', marginBottom: '14px' }}>
          <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '14px 16px' }}>
            <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: '6px' }}>Vendas no período</div>
            <div style={{ fontSize: '28px', fontWeight: '700', fontFamily: "'DM Mono',monospace", color: '#1E5FA5' }}>{vendas.length}</div>
          </div>
          {isAdmin && <>
            <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '14px 16px' }}>
              <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: '6px' }}>Receita total</div>
              <div style={{ fontSize: '20px', fontWeight: '700', fontFamily: "'DM Mono',monospace", color: '#2D7D4F' }}>{fmt(totalReceita)}</div>
            </div>
            <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '14px 16px' }}>
              <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: '6px' }}>Ticket médio</div>
              <div style={{ fontSize: '20px', fontWeight: '700', fontFamily: "'DM Mono',monospace", color: '#1E5FA5' }}>{fmt(totalReceita / vendas.length)}</div>
            </div>
          </>}
        </div>
      )}

      {/* Tabela */}
      <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '16px 18px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', color: '#9AA3AE', padding: '32px 0' }}>Carregando...</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Data', 'Veículo', 'Cliente', 'Vendedor', isAdmin ? 'Valor Final' : null, 'Entrega', 'Docs', isAdmin ? '' : null]
                  .filter(Boolean)
                  .map(h => <th key={h} style={th}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {vendas.length === 0 && (
                <tr><td colSpan={8} style={{ ...td, textAlign: 'center', color: '#9AA3AE', padding: '32px 0' }}>Nenhuma venda no período</td></tr>
              )}
              {vendas.map(v => (
                <tr key={v.id}>
                  <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', fontFamily: "'DM Mono',monospace" }}>{new Date(v.data_venda).toLocaleDateString('pt-BR')}</td>
                  <td style={{ ...td, fontWeight: '500' }}>{v.marca} {v.modelo}</td>
                  <td style={{ ...td, color: '#6B7A8D' }}>{v.cliente_nome}</td>
                  <td style={{ ...td, color: '#6B7A8D' }}>{v.vendedor_nome}</td>
                  {isAdmin && <td style={{ ...td, color: '#2D7D4F', fontWeight: '700', fontFamily: "'DM Mono',monospace", fontSize: '12px' }}>
                    <div>{fmt(v.valor_final)}</div>
                    {parseFloat(v.valor_recebido || 0) > 0 && parseFloat(v.valor_recebido||0) < parseFloat(v.valor_final||0) && (
                      <div style={{ fontSize: '10px', color: '#E67E22', marginTop: '2px' }}>Recebido: {fmt(v.valor_recebido)} · Saldo: {fmt(parseFloat(v.valor_final||0) - parseFloat(v.valor_recebido||0))}</div>
                    )}
                    {parseFloat(v.valor_recebido || 0) >= parseFloat(v.valor_final || 0) && parseFloat(v.valor_recebido||0) > 0 && (
                      <div style={{ fontSize: '10px', color: '#2D7D4F', marginTop: '2px' }}>✓ Quitado</div>
                    )}
                    {(!v.valor_recebido || parseFloat(v.valor_recebido) === 0) && (
                      <div style={{ fontSize: '10px', color: '#9AA3AE', marginTop: '2px' }}>Pendente</div>
                    )}
                    <button onClick={() => { setModalReceb(v); setFormReceb({ valor: (parseFloat(v.valor_final||0) - parseFloat(v.valor_recebido||0)).toFixed(2), forma: 'PIX', data: new Date().toISOString().split('T')[0] }); }}
                      style={{ marginTop: '4px', padding: '2px 7px', background: '#E6F1FB', border: 'none', color: '#1A3A5C', borderRadius: '5px', cursor: 'pointer', fontSize: '10px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                      + Recebimento
                    </button>
                  </td>}
                  <td style={td}>
                    <button onClick={(e) => abrirModalEntrega(v.id, e)}
                      style={{ padding: '4px 10px', background: v.data_entrega ? '#EAF5EE' : '#E6F1FB', border: 'none', color: v.data_entrega ? '#2D7D4F' : '#185FA5', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                      {v.data_entrega ? '✓ Entregue' : 'Marcar entrega'}
                    </button>
                  </td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <button onClick={(e) => abrirDoc('nf', v.id, e)} style={{ padding: '4px 7px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#1A3A5C', borderRadius: '6px', cursor: 'pointer', fontSize: '10px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Nota</button>
                      <button onClick={(e) => abrirDoc('garantia', v.id, e)} style={{ padding: '4px 7px', background: 'transparent', border: '1px solid #2D7D4F', color: '#2D7D4F', borderRadius: '6px', cursor: 'pointer', fontSize: '10px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Garantia</button>
                      <button onClick={(e) => abrirDoc('contrato', v.id, e)} style={{ padding: '4px 7px', background: 'transparent', border: '1px solid #185FA5', color: '#185FA5', borderRadius: '6px', cursor: 'pointer', fontSize: '10px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Contrato</button>
                    </div>
                  </td>
                  {isAdmin && (
                    <td style={td}>
                      <button onClick={() => abrirEditar(v)}
                        style={{ padding: '4px 10px', background: 'transparent', border: '1px solid #B06000', color: '#B06000', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>
                        Editar
                      </button>
                      <button onClick={() => cancelarVenda(v)}
                        style={{ padding: '4px 10px', background: '#FDECEA', border: 'none', color: '#C0392B', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>
                        Cancelar
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>


      {/* Modal Entrega */}
      {modalEntrega && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '360px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', marginBottom: '20px' }}>Marcar entrega</h3>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '6px', textTransform: 'uppercase' }}>Data de entrega</label>
              <input type='date' value={dataEntrega} onChange={e => setDataEntrega(e.target.value)}
                style={{ width: '100%', padding: '10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', fontSize: '14px', fontFamily: "'DM Sans',system-ui,sans-serif", color: '#1C2533' }} />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setModalEntrega(null)}
                style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Cancelar
              </button>
              <button onClick={confirmarEntrega}
                style={{ flex: 1, padding: '10px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Confirmar entrega
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar — só admin */}
      {modalEditar && isAdmin && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '620px', maxHeight: '88vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>Editar Venda #{form.id}</h3>
              <button onClick={() => { setModalEditar(false); setForm({}); }} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <form onSubmit={salvarEdicao}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Data da venda</label>
                  <input type='date' value={form.data_venda || ''} onChange={e => setV('data_venda', e.target.value)} style={inpStyle} />
                </div>
                <div style={{ marginBottom: '12px', gridColumn: '1 / -1' }}>
                  <label style={lbl}>Formas de pagamento</label>
                  {formasEdit.map((item, fi) => (
                    <div key={fi} style={{ display: 'flex', gap: '8px', marginBottom: '6px', alignItems: 'center' }}>
                      <select value={item.forma} onChange={e => setFormasEdit(f => f.map((x,idx) => idx===fi ? {...x, forma: e.target.value} : x))} style={{ ...inpStyle, flex: 2 }}>
                        <option value=''>Selecione</option>
                        {['Dinheiro','PIX','Cartão Crédito','Cartão Débito','Financiamento','Troca','Boleto'].map(o => <option key={o} value={o}>{o}</option>)}
                      </select>
                      <input type='number' placeholder='Valor (opcional)' value={item.valor}
                        onChange={e => setFormasEdit(f => f.map((x,idx) => idx===fi ? {...x, valor: e.target.value} : x))}
                        style={{ ...inpStyle, flex: 1 }} />
                      {formasEdit.length > 1 && (
                        <button type='button' onClick={() => setFormasEdit(f => f.filter((_,idx) => idx !== fi))}
                          style={{ padding: '8px 10px', background: '#FDECEA', border: 'none', color: '#C0392B', borderRadius: '6px', cursor: 'pointer', fontWeight: '700' }}>×</button>
                      )}
                    </div>
                  ))}
                  <button type='button' onClick={() => setFormasEdit(f => [...f, { forma: '', valor: '' }])}
                    style={{ padding: '7px 12px', background: 'transparent', border: '1px dashed rgba(26,58,92,0.3)', color: '#1A3A5C', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", width: '100%', marginTop: '2px' }}>
                    + Adicionar forma de pagamento
                  </button>
                  {formasEdit.filter(f => f.forma && f.valor).length > 0 && (
                    <div style={{ marginTop: '8px', padding: '8px 12px', background: '#EAF5EE', borderRadius: '7px', fontSize: '13px', color: '#2D7D4F', fontWeight: '600' }}>
                      Total: R$ {formasEdit.filter(f => f.valor).reduce((a,f) => a + parseFloat(f.valor||0), 0).toLocaleString('pt-BR', {minimumFractionDigits:2})}
                    </div>
                  )}
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Cliente</label>
                  <select value={form.cliente_id || ''} onChange={e => setV('cliente_id', e.target.value)} style={inpStyle}>
                    <option value=''>Selecione</option>
                    {clientes.map(c => <option key={c.id} value={String(c.id)}>{c.nome} — {c.cpf_cnpj}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Vendedor</label>
                  <select value={form.vendedor_id || ''} onChange={e => setV('vendedor_id', e.target.value)} style={inpStyle}>
                    <option value=''>Selecione</option>
                    {usuarios.map(u => <option key={u.id} value={String(u.id)}>{u.nome}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Veículo</label>
                  <select value={form.veiculo_id || ''} onChange={e => setV('veiculo_id', e.target.value)} style={inpStyle}>
                    <option value=''>Selecione</option>
                    {veiculos.map(v => <option key={v.id} value={String(v.id)}>{v.marca} {v.modelo} {v.ano_mod} — {v.placa || 'S/Placa'}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Valor do veículo</label>
                  <input type='number' step='0.01' value={form.valor_veiculo || ''} onChange={e => setV('valor_veiculo', e.target.value)} style={inpStyle} />
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Desconto</label>
                  <input type='number' step='0.01' value={form.valor_desconto || ''} onChange={e => setV('valor_desconto', e.target.value)} style={inpStyle} />
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Valor final</label>
                  <input type='number' step='0.01' value={form.valor_final || ''} onChange={e => setV('valor_final', e.target.value)} style={{ ...inpStyle, fontWeight: '700', color: '#2D7D4F' }} />
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <label style={lbl}>Valor transferência</label>
                  <input type='number' step='0.01' value={form.valor_transferencia || ''} onChange={e => setV('valor_transferencia', e.target.value)} style={inpStyle} />
                </div>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={lbl}>Observações</label>
                <input value={form.observacoes || ''} onChange={e => setV('observacoes', e.target.value)} style={inpStyle} />
              </div>
              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <button type='button' onClick={() => { setModalEditar(false); setForm({}); }}
                  style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                  Cancelar
                </button>
                <button type='submit' disabled={salvando}
                  style={{ flex: 1, padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                  {salvando ? 'Salvando...' : 'Salvar alterações'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    {modalRecebJSX}
    </div>
  );
}
